export default __webpack_public_path__ + "static/media/BitcoinGoldCoin.dcd79913.gif";